import { currencyApi } from './currencyApi'
import { currencyAdapters } from './currencyAdapters'
import { getWallet } from '@/domain/wallet'
import {
  CurrencyCatalogsDTO,
  CurrencyCatalogsParams,
  AboutCurrencyInBlockchainParams,
  AboutCurrencyInBlockchainDTO,
  AdaptedAboutCurrencyInBlockchainDTO,
} from './currencyTypes'

async function getCurrencies(
  params: CurrencyCatalogsParams,
): Promise<{ currencies: CurrencyCatalogsDTO[] }> {
  const result = await currencyApi.fetchCurrencies(params)
  return result
}

async function getAboutCurrencyInBlockchain(
  params: AboutCurrencyInBlockchainParams,
): Promise<AdaptedAboutCurrencyInBlockchainDTO> {
  const currencyInBlockchain =
    await currencyApi.getAboutCurrencyInBlockchain(params)
  const cryptoWallet = await getWallet()

  return currencyAdapters.adapterGetAboutCurrencyInBlockchain(
    currencyInBlockchain,
    cryptoWallet,
  )
}

export const currencyServices = {
  getCurrencies,
  getAboutCurrencyInBlockchain,
}
